module.exports = __webpack_public_path__ + "static/media/test-goat.ce8bdf02.jpg";